export default __webpack_public_path__ + "static/media/ICON1.5a8552ee.svg";